import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';

// A client for calling Ecomm BFFs
const createClient = () =>
  axios.create({
    baseURL: 'https://api.example.com',
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const axiosClientInstance = createClient();

const axiosClientRequest = async <T>(
  config: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  const response: AxiosResponse<T> = await axiosClientInstance({
    ...config,
  });

  return response;
};

export default axiosClientRequest;
